// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3tMDF","consentsList":"PatientConsents_consentsList__3SopG","consentsListEmpty":"PatientConsents_consentsListEmpty__2dOPM"};